export function queryBatchStatusV4(send) {
  return (batchId, ...args) =>
    send(
      {
        path: '/v4/payees/batch/{batchId}',
        pathParameters: { batchId },
        type: 'get',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
